// Save vuex state to localstorage

export default function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
